module.exports = __webpack_public_path__ + "static/media/industryInfo.b14a562a.png";